import * as XLSX from "xlsx";
import { classSubjects } from "../ResultsReport/subjects";

export const exportToExcel = (studentRecords, fileName, testName) => {
  const wb = XLSX.utils.book_new();
  const testType = testName.toLowerCase().includes("unit")
    ? "unitTest"
    : "termExam";

  const getMaxMarks = (sub) =>
    sub.maxMarks?.[testType] ?? sub.maxMarks ?? 100;

  // ================= ONLY THIS PART CHANGED - GRADE LOGIC =================
  // Same as ResultReport.jsx (94, 84, 69, 49, 39)
  const getGrade = (obtained, max) => {
    if (!obtained || obtained === "" || obtained === "-" || max === 0) return "";
    const numObtained = parseFloat(obtained);
    if (isNaN(numObtained) || numObtained > max) return "";
    
    const percentage = (numObtained / max) * 100;
    
    if (percentage >= 94) return "A+";
    if (percentage >= 84) return "A";
    if (percentage >= 69) return "B+";
    if (percentage >= 49) return "B";
    if (percentage >= 39) return "C";
    return "D";
  };

  /* ================= GROUP BY CLASS ================= */
  const classGroups = studentRecords.reduce((acc, st) => {
    (acc[st.class] ||= []).push(st);
    return acc;
  }, {});

  Object.entries(classGroups).forEach(([cls, students]) => {
    const wsData = [[`Result Report – Class ${cls} (${testName})`], []];
    const isPrepClass = ["Prep I", "Prep II", "Prep III"].includes(cls);
    const isHighSchool = ["6", "7", "8"].includes(cls);
    const includeCoScholastic = ["6", "7", "8"].includes(cls);

    const subjectsList = Array.isArray(classSubjects[cls]?.scholastic)
      ? classSubjects[cls].scholastic
      : classSubjects[cls]?.scholastic?.common || [];

    const subjectsOrder = Object.entries(
      subjectsList.reduce((a, s) => {
        (a[s.name] ||= []).push(s);
        return a;
      }, {})
    ).map(([main, subs]) => ({ main, subs }));

    /* ================= HEADER ================= */
    const header = ["Rank", "Student Name", "Student ID", "Section"];
    subjectsOrder.forEach(({ main, subs }) => {
      subs.forEach((sub) => {
        header.push(`${main} (${sub.spec || ""})`);
      });
      if (!isPrepClass) {
        if (isHighSchool && subs.length === 1) {
          header.push(`${main} Grade`);
        } else {
          header.push(`${main} Total`, `${main} Grade`);
        }
      }
    });
    if (!isPrepClass) {
      header.push("Grand Total", "Percentage", "Grade");
    }
    if (includeCoScholastic) {
      (classSubjects[cls]?.coScholastic || []).forEach((co) =>
        header.push(co.name)
      );
    }
    (classSubjects[cls]?.traitObservations || []).forEach((tr) =>
      header.push(`Observation: ${tr.name}`)
    );
    header.push("Remarks");
    wsData.push(header);

    /* ================= GRAND TOTAL FOR RANKING (OLD LOGIC - UNTOUCHED) ================= */
    students.forEach((st) => {
      st._grandTotal = subjectsOrder.reduce(
        (t, { subs }) =>
          t +
          subs.reduce(
            (x, s) => x + (Number(st.scholastic?.[s.id]) || 0),
            0
          ),
        0
      );
    });
    students.sort((a, b) => b._grandTotal - a._grandTotal);

    /* ================= ROWS ================= */
    students.forEach((st, i) => {
      const row = [i + 1, st.name, st.student_id, st.section];

      subjectsOrder.forEach(({ subs }) => {
        let total = 0;
        let max = 0;
        let hasMarks = false;

        subs.forEach((sub) => {
          const m = st.scholastic?.[sub.id];
          row.push(m ?? "");
          if (m !== "" && m != null) hasMarks = true;
          total += Number(m) || 0;
          max += getMaxMarks(sub);
        });

        if (!isPrepClass) {
          // ✅ ONLY GRADE CHANGED - using new getGrade()
          const grade = getGrade(total, max);

          if (isHighSchool && subs.length === 1) {
            row.push(grade);           // only grade
          } else {
            row.push(hasMarks ? total : "", grade);
          }
        }
      });

      /* ================= GRAND TOTAL, PERCENTAGE, GRADE (using new logic) ================= */
      if (!isPrepClass) {
        const maxTotal = subjectsOrder.reduce(
          (t, { subs }) =>
            t + subs.reduce((x, s) => x + getMaxMarks(s), 0),
          0
        );
        const pct = maxTotal ? (st._grandTotal / maxTotal) * 100 : 0;
        
        // ✅ Grade also using same new logic
        const grade = getGrade(st._grandTotal, maxTotal);

        row.push(st._grandTotal, pct.toFixed(2), grade);
      }

      /* ================= CO & OBSERVATIONS (UNTOUCHED) ================= */
      if (includeCoScholastic) {
        (classSubjects[cls]?.coScholastic || []).forEach((co) =>
          row.push(
            st.co_scholastic?.[co.id] ??
            st.co_scholastic_marks?.[co.id] ??
            ""
          )
        );
      }
      (classSubjects[cls]?.traitObservations || []).forEach((tr) =>
        row.push(
          st.observation?.[tr.id] ??
          st.traitRemarks?.[tr.id] ??
          ""
        )
      );
      row.push(st.remarks || "");
      wsData.push(row);
    });

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(
      wb,
      ws,
      cls.replace(/[/\\?*[\]]/g, "_")
    );
  });

  XLSX.writeFile(wb, `${fileName || "Result_Report"}.xlsx`);
};